import { CardInputWithType, ECardType, LinkInput } from '__generated__/globalTypes';
import { CreateGuideStoryVariables } from 'graphql/mutation/__generated__/CreateGuideStory';
import { GuideQuery_guide_stories } from 'graphql/query/__generated__/GuideQuery';

function parser(guideId: string, row: Record<string, string>): CreateGuideStoryVariables {
    const imageId = row['Logo Gdrive']
        .replace('https://drive.google.com/open?id=', '')
        .replace('&usp=drive_copy', '')
        .trim();
    const imageUrl = 'https://drive.google.com/uc?id=' + imageId;

    const mutationPayload: CreateGuideStoryVariables = {
        guideId,
        story: {
            importKey: row['Company']?.toLowerCase(),
            header: {
                title: row['Company'],
                text: row['Claim'],
                imageUrl
                // imageStyleId: 'stretch'
            }
        },
        cards: []
    };

    const hasDescriptionCard = row['Kdo jsme'];
    const descriptionCard: CardInputWithType = {
        type: ECardType.TEXT,
        info: {
            description: row['Kdo jsme']
        }
    };

    const hasLinkCard = row['Kontakt-web'] || row['Odkaz na web JF'];
    const linkCard: CardInputWithType = {
        type: ECardType.LINK,
        links: (() => {
            const links: LinkInput[] = [];
            if (row['Kontakt-web']) {
                links.push({
                    title: 'Web společnosti',
                    url: row['Kontakt-web']
                });
            }
            if (row['Odkaz na web JF']) {
                links.push({
                    title: 'Profil na JobFair',
                    url: row['Odkaz na web JF']
                });
            }
            return links;
        })()
    };

    const hasContactCard = row['Kontakt-email'] || row['Kontakt-tel'];
    const contactCard: CardInputWithType = {
        type: ECardType.TEXT,
        info: {
            title: 'Kontakt',
            description: (() => {
                let str = '';
                if (row['Kontakt-email']) {
                    str += `**Email:** ${row['Kontakt-email'].trim()}\n`;
                }
                if (row['Kontakt-tel']) {
                    str += `**Telefon:** ${row['Kontakt-tel'].trim()}\n`;
                }
                return str;
            })()
        }
    };

    const videos = row['video'].split('\n').map((e) => e.trim());

    const youtubeVideos = videos.filter((video) => video.toLowerCase().includes('youtu'));
    const nonYoutubeVideos = videos.filter((video) => !video.toLowerCase().includes('youtu'));

    if (hasDescriptionCard) {
        mutationPayload.cards.push(descriptionCard);
    }
    if (hasLinkCard) {
        mutationPayload.cards.push(linkCard);
    }
    if (hasContactCard) {
        mutationPayload.cards.push(contactCard);
    }

    for (const video of youtubeVideos) {
        mutationPayload.cards.push({
            type: ECardType.VIDEO,
            video: {
                videoId: video
            }
        });
    }
    if (nonYoutubeVideos.length > 0) {
        mutationPayload.cards.push({
            type: ECardType.LINK,
            links: nonYoutubeVideos.map((video) => ({ title: 'Video', url: video }))
        });
    }

    return mutationPayload;
}

function duplicateChecker(story: GuideQuery_guide_stories, row: Record<string, string>): boolean {
    return story.header?.title?.toLowerCase() === row['Company']?.toLowerCase();
}

export const vutImportMethods = { duplicateChecker, parser };
